var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMinusTeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 11.5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5H1.6C.8 8.5.1 9.2.1 10s.7 1.5 1.5 1.5h16.8z",
    fill: "#009baf"
  })));
}

export default SvgIconMinusTeal;